export default "/a5b48e0946994335e17e220415b7ad8a9ff4e295/ed3e1222f5d7e466f1889a4510f1de5c.svg";